<template>
	<div class="not-found">
		<img
			class="not-found__img"
			src="~@/assets/404.png"
			alt="Dead End graphic for page not found"
		/>
		<h2 class="not-found__title">
			Oops 404! <br />Looks like you took a wrong turn.
		</h2>
		<p class="not-found__message">
			Let’s try another route and get you on your way.
		</p>
		<div class="not-found__actions">
			<router-link to="/" class="btn btn--primary"
				>Go to Clients</router-link
			>
		</div>
	</div>
</template>

<script>
export default {
	Name: 'NotFound'
};
</script>

<style lang="scss" scoped>
/**
    * No results found
    * Can use SCSS variables = TRUE
*/

.not-found {
	padding: $padding-sm * 9 0;
	margin: 0 auto;
	max-width: 420px;
	text-align: center;

	&__img {
		height: auto;
	}

	&__title {
		font-size: $default-font-size + 4;
		margin-bottom: $gutter-md;
		font-weight: $medium-font-weight;
		line-height: normal;
		@include text-contrast($page-body-bkgd, $white, $black);
	}

	&__message {
		font-size: $default-font-size - 2;
		@include text-contrast($page-body-bkgd, $white, $black);
	}

	&__actions {
		margin-top: $gutter-xl;
		.btn {
			display: inline-block;
		}
	}
}
</style>
